/* tslint:disable */
/* eslint-disable */
/**
 * The Thing API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum AlertType {
    FixInProgress = 0,
    FixInProgressAcknowledged = 1,
    ResolvedReupload = 2,
    ResolvedProceed = 3,
    ResolvedOther = 4
}

export function AlertTypeFromJSON(json: any): AlertType {
    return AlertTypeFromJSONTyped(json, false);
}

export function AlertTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): AlertType {
    return json as AlertType;
}

export function AlertTypeToJSON(value?: AlertType | null): any {
    return value as any;
}

